import React, { PureComponent } from "react";

import tvgConf from "@tvg/conf";
import FundingMethodsHOC from "@tvg/funding-methods";
import perf from "../utils/perf";

class RgFundingMethods extends PureComponent {
  static defaultProps = {
    device: "mobile"
  };

  componentDidUpdate() {
    perf.measure("page_render", { page: "responsible_gaming" });
  }

  render() {
    return (
      <FundingMethodsHOC
        device={this.props.device}
        depositURL={tvgConf().buildUrl({
          app: "dma",
          path: "deposit",
          wrapper: true,
          callback: true,
          params: { fullPage: true, more: true }
        })}
      />
    );
  }
}

export default RgFundingMethods;
